import { createContext } from 'react';
import { GameGlobals } from 'engine/game';

export const GameGlobalsContext = createContext<Partial<GameGlobals>>({});
